import { render, staticRenderFns } from "./ORadio.vue?vue&type=template&id=1ed75bb9&scoped=true"
import script from "./ORadio.vue?vue&type=script&lang=js"
export * from "./ORadio.vue?vue&type=script&lang=js"
import style0 from "./ORadio.vue?vue&type=style&index=0&id=1ed75bb9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed75bb9",
  null
  
)

export default component.exports